import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import NavbarTechnician from "../../../commons/NavbarTechnician";
import Title from "../../../pages/Login/Components/title/title";
import CardRequest from "./Component/CardRequest";

class Request_available extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }
  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="dentAvailable" className="d-none">
          <Title text1="Please, press on the card to select it" />
        </div>
        <CardRequest />
        <br />
        <br />
        <br />
        <br />
        <NavbarTechnician />
      </React.Fragment>
    );
  }
}
export default Request_available;
